import { PageLoading, useMedia } from '@bounty/creators-design-system'
import { ShopDetailScreenDesktop } from './components/ShopDetailScreenDesktop'
import { ShopDetailScreenMobile } from './components/ShopDetailScreenMobile'
import { createParam } from 'solito'
import { ShopDetailContext } from './ShopDetailContext'
import { useSWRBounty } from '../../../hooks/swr'
import { useTrackPage } from '../../../hooks/useTrackPage'

const { useParam } = createParam()

export type ShopDetailScreenProps = any

const ShopDetailPageTrack = ({ params }: { params: Record<string, any> }) => {
  useTrackPage('Shop Detail', params)
  return null
}

export const ShopDetailScreen = () => {
  const [slug] = useParam('slug')

  if (!slug) {
    throw new Error('Cannot find required param slug!')
  }

  const { data } = useSWRBounty('getStore', slug, {
    views: '1000',
    includeDisabledStores: 'false',
  })
  const { gtMd } = useMedia()

  if (!data || !data?.data) return <PageLoading />

  if (!data.success) return null

  const eventParams = {
    shopUrl: data.data.shopUrl,
    shopRedirectUrl: data.data.redirectUrl,
    isFeatured: data.data.featured,
    shopName: data.data.name,
    shopeSlug: data.data.slug,
    minimumPayout: data.data.minBountyPayment,
    startingCPM: data.data.startingCPM,
    hasDeals: !!data.data.deals,
  }

  return (
    <ShopDetailContext
      initialValue={{
        redirectUrl: data.data.redirectUrl,
        eventParams,
        signUpScreenOpen: false,
        productId: '',
      }}
    >
      <ShopDetailPageTrack params={eventParams} />
      {gtMd ? (
        <ShopDetailScreenDesktop shop={data.data} />
      ) : (
        <ShopDetailScreenMobile shop={data.data} />
      )}
    </ShopDetailContext>
  )
}
